import { Link } from 'react-router-dom';
import { useState } from 'react';
import { ArrowUp, X, Sparkles } from 'lucide-react';
import { useFeatures } from '../../context/FeaturesContext';

/**
 * UpgradeBanner — persistent banner inviting the user to upgrade.
 *
 * Shown only when the user has an `upgradeTo` available
 * (i.e. they're not on the top tier of their track).
 *
 * Dismissible per session via sessionStorage.
 */
const UpgradeBanner = () => {
  const { tierLabel, upgradeTo, loading } = useFeatures();
  const dismissKey = `onor_upgrade_dismissed_${upgradeTo?.plan_id || 'none'}`;
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && sessionStorage.getItem(dismissKey) === '1'
  );

  if (loading || !upgradeTo || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(dismissKey, '1');
    setDismissed(true);
  };

  return (
    <div
      className="relative flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-primary/15 to-primary/5 border-b border-primary/30"
      data-testid="upgrade-banner"
    >
      <Sparkles className="w-4 h-4 text-primary flex-shrink-0" />
      <p className="text-zinc-300 text-sm flex-1">
        Estás en <span className="text-primary font-medium">{tierLabel}</span>.{' '}
        <Link to="/planes" className="text-primary hover:text-primary/80 underline">
          Sube a {upgradeTo.display_name}
        </Link>{' '}
        para desbloquear más funciones.
      </p>
      <Link
        to="/planes"
        className="hidden sm:inline-flex items-center gap-1 px-3 py-1 bg-primary text-white text-xs font-bold rounded-sm hover:bg-primary/90 transition-colors uppercase tracking-wider"
      >
        <ArrowUp className="w-3 h-3" />
        Subir
      </Link>
      <button
        onClick={handleDismiss}
        className="text-zinc-500 hover:text-zinc-300 transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default UpgradeBanner;
